export default function generateRequestHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token'),
  };
}
